var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      attrs: {
        "aria-haspopup": "true",
        "aria-expanded": String(_vm.isModalVisible)
      },
      on: { click: _vm.openModal }
    },
    [
      _c("div", { staticClass: "atbName" }, [
        _vm._v("\n        " + _vm._s(_vm.displayName) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        _vm.modalComponent,
        _vm._g(
          {
            tag: "component",
            attrs: {
              settings: _vm.modalSettings,
              "is-visible": _vm.isModalVisible
            },
            on: { close: _vm.hideModal }
          },
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }